/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react'

import useViewResultModeStore from 'store/viewResultMode'
import useExamInform from '@hooks/useExamInform'
import { useQuestion } from '@hooks/reactQuery/useQuestion'
import { PassageProps } from '@components/Passages'
import { ChoiceProps } from '@components/Choices/Choice'
import QuestionAndChoices, {
  QuestionAndChoicesType,
} from '@components/QuestionAndChoices/QuestionAndChoices'

export type QuestionProps = {
  id: number
  number: number
  text: string
  passages: PassageProps[]
  choices: ChoiceProps[]
}

export type QuestionAndChoicesProps = {
  questionId: number
  isDelivery?: boolean
}

const QuestionAndChoicesContainer: React.FC<QuestionAndChoicesProps> = ({
  questionId,
  isDelivery,
}) => {
  const { getAnswerResultByQuestionNumber, getQuestionNumber } = useExamInform(isDelivery)
  const { viewResultMode } = useViewResultModeStore()
  const [answerNumber, setAnswerNumber] = useState(0)
  const [isCorrect, setIsCorrect] = useState(false)
  const [explanationId, setExplanationId] = useState<number | undefined>(undefined)
  const { data: question, isLoading, error } = useQuestion(questionId)

  const questionNumber = useMemo(() => {
    return getQuestionNumber(questionId) || 1
  }, [questionId])

  useEffect(() => {
    const setAnswerResult = () => {
      if (question != null) {
        const answerResult = getAnswerResultByQuestionNumber(questionNumber)
        setAnswerNumber(answerResult?.answer ? answerResult.answer : 0)
        if (answerResult?.result) {
          setIsCorrect(true)
        } else {
          setIsCorrect(false)
        }
        setExplanationId(answerResult?.explanationId)
      }
    }
    if (viewResultMode) {
      setAnswerResult()
    }
  }, [viewResultMode, question, questionNumber, getAnswerResultByQuestionNumber])

  const questionTitle = useMemo(() => {
    return `${questionNumber}. ${question?.text}`
  }, [questionNumber, question?.text])

  const passages =
    question != null
      ? question?.passages?.map(({ id, questionId, number, text, image }) => ({
          id,
          questionId,
          number,
          text,
          image,
        }))
      : []

  if (isLoading) {
    return <div></div>
  }

  if (error || !question) {
    return <div>오류가 생겼습니다.</div>
  }

  const props: QuestionAndChoicesType = {
    viewResultMode,
    questionTitle,
    questionNumber,
    passages,
    choices: question.choices,
    answerNumber,
    isCorrect,
    isDelivery,
    explanationId,
  }

  return <QuestionAndChoices {...props} />
}

export default QuestionAndChoicesContainer
